import { useEffect, useState } from 'react'

/**
 * Debounces a value. Returns the value only after it has remained unchanged
 * for delayMs. Resets the timer on every change—intermediate values are
 * discarded until the value settles.
 *
 * @param value The value to debounce
 * @param delayMs Milliseconds of inactivity before emitting
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
